module.exports = __webpack_public_path__ + "img/56.e34a565d.png";